
































import Vue from "vue"
import { address } from "thor-devkit"

export default Vue.extend({
    props: {
        address: String,
        abbr: Boolean,
        icon: Boolean,
        noLink: Boolean
    },
    computed: {
        isValid(): boolean {
            return address.test(this.address);
        }
    }
})
